import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=1bc2fd52&"
import script from "./PromoCodes.vue?vue&type=script&lang=js&"
export * from "./PromoCodes.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&id=1bc2fd52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports